import styled, { css } from "styled-components";
import { fluid } from "./utils/fluid";

export const TypoButtonStyles = css`
  font-family: ${({ theme }) => theme.fontFace.itc_avant_garde_gothicbold};
  letter-spacing: ${({ theme }) => theme.letterSpacing.button};
  line-height: ${({ theme }) => theme.lineHeight.button};
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  margin: 0;
  border-radius: 9999em;
  box-sizing: border-box;
  white-space: nowrap;
  width: auto;
  font-size: ${({ theme }) =>
    fluid({
      minSize: theme.fontScale.majorSecond.size,
      maxSize: theme.fontScale.augmentedFourth.size,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  padding: ${({ theme }) => `
    calc(${fluid({
      minSize: theme.spacing.button.xs,
      maxSize: theme.spacing.button.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })} / 2)
    ${fluid({
      minSize: theme.spacing.button.xs,
      maxSize: theme.spacing.button.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
      `};
  a {
    color: ${({ theme }) => theme.colors.white};
  }
`;

/* Extending Styles */
export const PrimaryButton = styled.button`
  ${TypoButtonStyles}
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.imperialRed};
  color: ${({ theme }) => theme.colors.white};
  transition:
    background-color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out,
    color 0.3s ease-in-out;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.begonia};
  }
  &:focus {
    box-shadow:
      0 0 0 4px ${({ theme }) => theme.colors.white},
      0 0 0 16px ${({ theme }) => theme.colors.linen};
    outline: 0;
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.firebrick};
  }
`;

export const SecondaryButton = styled.button`
  ${TypoButtonStyles}
  background-color: ${({ theme }) => theme.colors.lightRed};
  color: ${({ theme }) => theme.colors.imperialRed};
  transition:
    background-color 0.3s ease-in-out,
    box-shadow 0.3s ease-in-out,
    color 0.3s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.colors.white};
  }
  &:focus {
    box-shadow:
      0 0 0 4px ${({ theme }) => theme.colors.white},
      0 0 0 16px ${({ theme }) => theme.colors.linen};
    outline: 0;
  }
  &:active {
    color: ${({ theme }) => theme.colors.firebrick};
  }
`;
